import React from "react";
import { Card, CardContent } from "src/components/ui/Card";
import image2 from "src/assets/rectangle-image-2.png";
import image3 from "src/assets/rectangle-image-3.png";
import image6 from "src/assets/rectangle-image-6.png";

import "./TeamSection.scss";

const largeTeamMembers = [
  {
    name: "Michael Scott",
    role: "General Manager",
    image: image2,
  },
  {
    name: "Michael Scott",
    role: "General Manager",
    image: image2,
  },
  {
    name: "Michael Scott",
    role: "General Manager",
    image: image2,
  },
];

const smallTeamMembers = [
  {
    name: "Dwight Schrute",
    role: "General Manager",
    image: image3,
  },
  {
    name: "Pam Beetsley",
    role: "General Manager",
    image: image6,
  },
  {
    name: "Pam Beetsley",
    role: "General Manager",
    image: image6,
  },
  {
    name: "Pam Beetsley",
    role: "General Manager",
    image: image6,
  },
];

const TeamSection = () => {
  return (
    <section className="team-section">
      <div className="team-section__container">
        <header className="team-section__header">
          <div className="team-section__title-container">
            <p className="team-section__subtitle">Our team</p>

            <h2 className="team-section__title">The people behind the work</h2>
          </div>

          <p className="team-section__description">
            Conversion angel investor entrepreneur first mover advantage.
            Handshake infographic mass market crowdfunding iteration. Traction
            stock user experience deployment beta innovator incubator focus.
          </p>
        </header>

        <div className="team-section__members">
          <div className="team-section__large-members">
            {largeTeamMembers.map(({ name, image, role }, index) => (
              <Card
                key={`large-member-${index}`}
                className="team-section__card"
              >
                <CardContent className="team-section__card-content">
                  <img
                    className="team-section__large-image"
                    alt={name}
                    src={image}
                  />

                  <div className="team-section__member-info">
                    <h3 className="team-section__member-name">{name}</h3>

                    <p className="team-section__member-role">{role}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="team-section__small-members">
            {smallTeamMembers.map(({ name, image, role }, index) => (
              <Card
                key={`small-member-${index}`}
                className="team-section__card"
              >
                <CardContent className="team-section__small-card-content">
                  <img
                    className="team-section__small-image"
                    alt={name}
                    src={image}
                  />

                  <div className="team-section__small-member-info">
                    <h3 className="team-section__member-name">{name}</h3>

                    <p className="team-section__member-role">{role}</p>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TeamSection;
